<!-- 消息组件 -->
<template>
    <!-- 折叠框 -->
    <van-popup v-model="popupshow" class="message-popup" :lock-scroll="true" :close-on-click-overlay="false"
        position="bottom" :style="{ height: '100%' }">
        <div class="message-context">
            <div class="message-context-header">
                <div class="mess-header-title">
                    郑州华夏白癜风医院人工服务
                </div>
                <img class="mess-header-icon" @click="Closepopup" src="@/assets/icon/quxiao_qiantou.png" alt="">
            </div>
            <iframe class="message-iframe" frameborder="0" scrolling="no"
                src="https://c-24004.p.easyliao.com/live/chat.do?c=24004&g=10107287&config=31591&ref=youhua"></iframe>

            <!-- 确定关闭 -->
            <van-dialog v-model="dialogshow" title="" overlayClass="van-dialog-overlay" className="van-dialog-class"
                :show-cancel-button="false" :show-confirm-button="false">
                <div class="van-dialog-box">
                    <div class="van-dialog-box-title">对话窗口即将关闭，您可以复制我院微信{{ this.$store.state.phonecall }}进行24小时咨询，是否关闭?
                    </div>
                    <ul class="van-dialog-box-botton">
                        <li class="van-dialog-botton-close" @click="Confirmclose">取消</li>
                        <li class="van-dialog-botton-queding" @click="Confirmclose">确定</li>
                    </ul>
                </div>
            </van-dialog>
        </div>
    </van-popup>
</template>

<script>
export default {
    data() {
        return {
            popupshow: false,
            dialogshow: false,
        }
    },
    methods: {
        Showpopup(isfleg = true) {
            this.popupshow = isfleg

        },
        Closepopup() {
            this.dialogshow = true
        },
        Confirmclose() {
            this.popupshow = false
            this.dialogshow = false
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .van-overlay {
    background-color: rgba(0, 0, 0, .4) !important;
}

.van-dialog-class {
    position: absolute !important;
}

.van-dialog-box {
    padding: 30px;
    box-sizing: border-box;

    .van-dialog-box-botton {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .van-dialog-botton-close {
            width: 46%;
            height: 34px;
            line-height: 34px;
            color: #fff;
            background: #2cd2cc;
            border-radius: 5px;
            font-size: 13px;
            text-align: center;
        }

        .van-dialog-botton-queding {
            width: 46%;
            height: 34px;
            line-height: 34px;
            color: #2cd2cc;
            border: 1px solid #2cd2cc;
            border-radius: 5px;
            font-size: 13px;
            text-align: center;
        }
    }

    .van-dialog-box-title {
        font-size: 13px;
        color: #333;
        line-height: 25px;
    }
}

.message-popup {
    width: 100%;
    border-radius: 10px 10px 0 0;
    padding: 0;

    .message-context {
        width: 100%;
        height: 100%;
        position: relative;

        .message-iframe {
            width: 100%;
            height: 100%;
            border: none;
        }

        .message-context-header {
            width: 100%;
            height: 52px;
            background: #2CD2CC;
            padding: 5px;
            position: absolute;
            top: 0;
            left: 0;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .mess-header-title {
                font-size: 14px;
                font-weight: bold;
                color: #fff;
                letter-spacing: 1px;
            }

            .mess-header-icon {
                width: 30px;
                height: 30px;
            }
        }
    }
}
</style>